<template>
  <div class="page-box">
    <div class="page-content">
      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">预约信息</div>
          <div class="banner-arrow">{{ detailsObj.weekDay }}</div>
        </div>

        <div class="list-main" style="padding: 0 10px">
          <van-field label="姓名：" v-model="detailsObj.name" readonly>
            <template #left-icon>
              <van-image class="size-icon" src="/static/images/people.png" />
            </template>
          </van-field>

          <!--<van-field label="部门：" v-model="detailsObj.company" readonly>
            <template #left-icon>
              <van-image
                class="size-icon"
                src="/static/images/department.png"
              />
            </template>
          </van-field>-->

          <van-field label="电话：" v-model="detailsObj.phone" readonly>
            <template #left-icon>
              <van-image class="size-icon" src="/static/images/phone.png" />
            </template>
          </van-field>

          <van-field
            label="门卡："
            v-if="facility.isWeixin"
            v-model="detailsObj.gateCard"
            readonly
          >
            <template #left-icon>
              <van-image class="size-icon" src="/static/images/email.png" />
            </template>
          </van-field>
        </div>
      </div>

      <div class="list-box" v-if="detailsObj.servicePosition">
        <div class="banner-title-box">
          <div class="banner-title">地点</div>
        </div>
        <div class="list-main">
          {{ detailsObj.servicePosition }}
        </div>
      </div>

      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">服务内容</div>
        </div>
        <div
          class="list-main"
          style="display: flex; justify-content: space-between"
        >
          <div v-if="!detailsObj.additionalSpuName">
            {{ detailsObj.serviceContent }}
          </div>
          <div v-else>
            {{
              detailsObj.serviceContent &&
              detailsObj.serviceContent.split("|")[0]
            }}|{{ detailsObj.additionalSpuName }}
          </div>
          <div class="item-price">
            <span class="unit1">¥</span>{{ detailsObj.orderAmount === 0 ? '免费' : detailsObj.orderAmount }}
          </div>
        </div>
      </div>

      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">预约单信息</div>
        </div>
        <div class="list-main">
          <van-field
            label="预约单编号："
            v-model="detailsObj.orderNo"
            readonly
          />

          <van-field
            label="下单时间："
            v-model="detailsObj.orderTime"
            readonly
          />
        </div>
      </div>

      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">状态</div>
          <div class="banner-arrow">{{ detailsObj.orderStatus }}</div>
        </div>
        <div
          class="list-main"
          v-if="detailsObj.status === 44 || detailsObj.status === 43"
        >
          <template v-if="detailsObj.status === 44">
            <van-field
              label="取消类型："
              v-model="detailsObj.orderCloseType"
              readonly
            />
            <van-field
              label="取消人："
              v-model="detailsObj.updateUser"
              readonly
            />
            <van-field
              label="取消时间："
              v-model="detailsObj.updateTime"
              readonly
            />
          </template>

          <template v-if="detailsObj.status === 43">
            <van-field
              label="核销人："
              v-model="detailsObj.updateUser"
              readonly
            />
            <van-field
              label="核销时间："
              v-model="detailsObj.updateTime"
              readonly
            />
          </template>
        </div>
      </div>
    </div>
    <div class="list-box appointment-box" v-if="detailsObj.status === 42">
      <div class="cancel-btn" @click="handleMyCancel">取消订单</div>
      <div class="appointment-btn" @click="showQrCode">出示服务码</div>
    </div>

    <div class="dialog-box" v-show="innerVisible">
      <div id="qrcode" ref="qrcode"></div>
    </div>
    <div class="dialog-bg" v-show="innerVisible" @click="hideDialog"></div>
    <van-dialog
      v-model="show"
      :closeOnClickOverlay="true"
      confirmButtonColor="#ffffff"
      confirmButtonText="提交"
      title="取消原因"
      :before-close="onBeforeClose"
      @confirm="handleConfirm"
    >
      <van-form ref="myform">
        <van-field
          v-model="closeReason"
          ref="fieldRef"
          type="textarea"
          rows="4"
          maxlength="50"
          show-word-limit
          autosize
          name="closeReason"
          :rules="[{ required: true, message: '取消原因不能为空' }]"
          placeholder="请填写取消原因，有助于商家更好的处理问题。"
        />
      </van-form>
    </van-dialog>
  </div>
</template>
<script>
import {
  getMakeAnAppointmentDetails,
  makeAnAppointmentCancel,
} from "@/api/index";
import QRCode from "qrcodejs2";
import utils from "@/common/js/utils";
export default {
  name: "orderDetails",
  data() {
    return {
      facility: {},
      closeReason: "",
      detailsObj: {},
      notService: "待服务",
      alreadyCancel: "",
      clientCancel: "已取消",
      accomplish: "",
      innerVisible: false,
      show: false,
    };
  },
  created() {
    this.facility = utils.BrowserInfo();
    this.getDetailsMethod();
  },
  methods: {
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        this.$refs["myform"].resetValidation("closeReason");
        this.closeReason = "";
        return done();
      }
    },
    handleConfirm() {
      this.$refs["myform"]
        .validate()
        .then(async () => {
          let res = await makeAnAppointmentCancel({
            primaryKey: this.$route.query.orderKey,
            closeType: 4, // 客户取消是4
            closeReason: this.closeReason,
          });
          if (res.success) {
            this.$toast.success("取消成功");
            this.show = false;
            if (res.success) {
              this.$router.push({
                path: "/myMakeAnAppointment",
              });
            }
          }
        })
        .catch(() => {});
    },
    handleMyCancel() {
      this.closeReason = "";
      this.show = true;
    },
    async getDetailsMethod() {
      const detailsResult = await getMakeAnAppointmentDetails(
        this.$route.query.orderKey
      );

      if (detailsResult.success) {
        detailsResult.data.orderTime = utils.formatDate(
          detailsResult.data.orderTime
        );
        detailsResult.data.updateTime = utils.formatDate(
          detailsResult.data.updateTime
        );
        this.detailsObj = detailsResult.data;
      }
    },
    // 展示二维码
    showQrCode() {
      this.innerVisible = true;
      this.$nextTick(() => {
        this.crateQrcode(
          `/service/orderDetails?orderKey=${this.$route.query.orderKey}&qrCode=true`
        );
      });
    },
    // 生成二维码
    crateQrcode(qrcode) {
      this.qr = new QRCode("qrcode", {
        width: 150,
        height: 150, // 高度
        text: qrcode, // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
    },
    // 关闭弹框,清除已经生成的二维码
    hideDialog() {
      this.$refs.qrcode.innerHTML = "";
      this.innerVisible = false;
      setTimeout(() => {
        this.getDetailsMethod();
      }, 1500);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .van-dialog {
  .van-dialog__header {
    padding: 20px 16px;
    color: #333333;
    font-weight: bold;
  }
  .van-dialog__content {
    /deep/ .van-field--error .van-field__control,
    .van-field--error .van-field__control::placeholder {
      color: #969799 !important;
    }
    .van-cell {
      padding: 0px 16px;
      .van-cell__value {
        .van-field__body {
          .van-field__control {
            background: #eeeeee;
            padding: 10px 0px 0px 10px;
            color: #666666;
            border-radius: 15px;
          }
        }
        .van-field__word-limit {
          position: absolute;
          bottom: 24px;
          right: 10px;
        }
      }
    }
  }
  .van-dialog__footer {
    margin: 20px 16px;
    .van-button {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #16aa77;
      border-radius: 20px;
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      .van-button__text {
        color: #ffffff;
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .van-dialog__footer::after {
    border: initial;
  }
}
.page-box {
  background: #eeeeee;
  padding: 0 12px 10px;

  .custom-image {
    /deep/ .van-empty__image {
      width: 90px;
      height: 90px;

      img {
        width: 90px;
        height: 90px;
      }
    }
  }
}

.list-box {
  margin-top: 10px;
  border-radius: 5px;
  background: #fff;
  .banner-title-box {
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #d8d8d8;

    .banner-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin-right: 10px;
    }

    .banner-arrow {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;

      .van-icon {
        margin-left: 5px;
      }
    }
  }

  .list-main {
    padding: 15px 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;

    .van-cell {
      padding: 10px 0;
      align-items: center;

      &:after {
        right: 0px;
        left: 22px;
      }

      /deep/ .van-field__left-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .size-icon {
        width: 50%;
        height: 50%;
        margin-right: 2px;
      }
    }

    .item-price {
      display: flex;
      align-items: center;
      color: #16aa77;
      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 600;
      .desc {
        margin-right: 5px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
      }
      .unit1 {
        font-size: 12px;
        font-family: PingFangSC-Semibold;
      }
      .unit2 {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        color: #666666;
      }
    }
  }
}

.appointment-box {
  padding: 15px 5px;
  display: flex;

  .cancel-btn {
    flex: 1;
    margin: 0 10px;
    background: #c9c9c9;
    border-radius: 20px;
    height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .appointment-btn {
    flex: 1;
    margin: 0 5px;
    background: #16aa77;
    border-radius: 20px;
    height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.notService {
  padding-top: 12px;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
  width: 100%;
  .van-button {
    width: 170px;
    height: 40px;
  }
  .cancel {
    border-radius: 4px;
    border: 1px solid #19c37c;
    margin-right: 11px;
    .van-button__text {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #19c37c;
      line-height: 22px;
    }
  }
  .scan-code {
    background: #19c37c;
    border-radius: 4px;
    border: 1px solid #19c37c;
    .van-button__text {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 22px;
    }
  }
}

.dialog-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  padding: 10px;
}
.dialog-bg {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
}
</style>
